<template>
  <v-card flat class="pa-4">
    <!-- Snackbar -->
    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

    <!-- Botón nuevo -->
    <v-row class="mb-3">
      <v-col>
        <v-btn color="deep-purple" dark @click="openDialog(null)">
          <v-icon left>mdi-plus</v-icon> Nuevo Organizador
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Id</th>
            <th>Nombre</th>
            <th>Email</th>
            <th>Teléfono</th>
            <th>Redes</th>
            <th>Eventos</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="org in organizadores" :key="org.id">
            <td>{{ org.id }}</td>
            <td>{{ org.name }}</td>
            <td>{{ org.email || '—' }}</td>
            <td>{{ org.phone || '—' }}</td>
            <td>
              <v-icon v-if="org.url_web" small color="grey darken-1" class="mr-1">mdi-web</v-icon>
              <v-icon v-if="org.url_instagram" small color="purple" class="mr-1">mdi-instagram</v-icon>
              <v-icon v-if="org.url_facebook" small color="blue" class="mr-1">mdi-facebook</v-icon>
              <v-icon v-if="org.url_youtube" small color="red">mdi-youtube</v-icon>
              <span v-if="!org.url_web && !org.url_instagram && !org.url_facebook && !org.url_youtube" class="grey--text">—</span>
            </td>
            <td>{{ org.events_count || 0 }}</td>
            <td>
              <v-btn icon color="primary" small @click="openDialog(org)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon color="red" small @click="eliminar(org)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
          <tr v-if="organizadores.length === 0">
            <td colspan="7" class="text-center grey--text pa-4">No hay organizadores registrados.</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <!-- Dialog crear/editar -->
    <v-dialog v-model="dialog" max-width="600" persistent scrollable>
      <v-card>
        <v-card-title class="deep-purple darken-1 white--text">
          <v-icon left dark>mdi-account-group</v-icon>
          {{ editando ? 'Editar' : 'Nuevo' }} Organizador
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="formOrg" v-model="validForm">

            <v-text-field v-model="form.name" label="Nombre *"
              :rules="[v => !!v || 'Requerido']" outlined dense></v-text-field>

            <v-textarea v-model="form.description" label="Descripción"
              outlined dense rows="2"></v-textarea>

            <v-divider class="my-3"></v-divider>
            <p class="subtitle-2 grey--text text--darken-1 mb-2">Redes sociales</p>

            <v-text-field v-model="form.url_web" label="Sitio Web"
              prepend-inner-icon="mdi-web" outlined dense placeholder="https://"></v-text-field>

            <v-text-field v-model="form.url_instagram" label="Instagram"
              prepend-inner-icon="mdi-instagram" outlined dense placeholder="https://instagram.com/..."></v-text-field>

            <v-text-field v-model="form.url_facebook" label="Facebook"
              prepend-inner-icon="mdi-facebook" outlined dense placeholder="https://facebook.com/..."></v-text-field>

            <v-text-field v-model="form.url_youtube" label="YouTube"
              prepend-inner-icon="mdi-youtube" outlined dense placeholder="https://youtube.com/..."></v-text-field>

            <v-divider class="my-3"></v-divider>
            <p class="subtitle-2 grey--text text--darken-1 mb-2">Contacto</p>

            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="form.email" label="Email"
                  prepend-inner-icon="mdi-email" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="form.phone" label="Teléfono"
                  prepend-inner-icon="mdi-phone" outlined dense></v-text-field>
              </v-col>
            </v-row>

          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="deep-purple" dark :loading="saving" @click="guardar">
            {{ editando ? 'Actualizar' : 'Guardar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import eventService from '@/services/eventService.js';

export default {
  name: 'EventOrganizerAdmin',
  data() {
    return {
      organizadores: [],
      dialog: false,
      editando: false,
      validForm: true,
      saving: false,
      form: {
        id: null,
        name: '',
        description: '',
        url_web: '',
        url_instagram: '',
        url_facebook: '',
        url_youtube: '',
        email: '',
        phone: ''
      },
      mensaje: {
        snackbar: false,
        text: '',
        color: '',
        colorBtn: '',
        timeout: 4000
      }
    };
  },
  mounted() {
    this.listar();
  },
  methods: {
    listar() {
      eventService.listarOrganizadores().then(res => {
        this.organizadores = res.data;
      }).catch(() => {
        this.showMsg('Error al cargar organizadores', 'error');
      });
    },
    openDialog(org) {
      if (org) {
        this.editando = true;
        this.form = {
          id: org.id,
          name: org.name,
          description: org.description || '',
          url_web: org.url_web || '',
          url_instagram: org.url_instagram || '',
          url_facebook: org.url_facebook || '',
          url_youtube: org.url_youtube || '',
          email: org.email || '',
          phone: org.phone || ''
        };
      } else {
        this.editando = false;
        this.form = {
          id: null, name: '', description: '',
          url_web: '', url_instagram: '', url_facebook: '', url_youtube: '',
          email: '', phone: ''
        };
      }
      this.dialog = true;
    },
    async guardar() {
      if (!this.$refs.formOrg.validate()) return;

      this.saving = true;
      try {
        if (this.editando) {
          await eventService.updateOrganizador(this.form.id, this.form);
          this.showMsg('Organizador actualizado', 'success');
        } else {
          await eventService.saveOrganizador(this.form);
          this.showMsg('Organizador creado', 'success');
        }
        this.dialog = false;
        this.listar();
      } catch (err) {
        const msg = err.response && err.response.data && err.response.data.message;
        this.showMsg(msg || 'Error al guardar', 'error');
      } finally {
        this.saving = false;
      }
    },
    eliminar(org) {
      if (!confirm('¿Eliminar el organizador "' + org.name + '"?')) return;
      eventService.deleteOrganizador(org.id).then(() => {
        this.showMsg('Organizador eliminado', 'success');
        this.listar();
      }).catch(() => {
        this.showMsg('Error al eliminar', 'error');
      });
    },
    showMsg(text, type) {
      this.mensaje.text = text;
      this.mensaje.color = type === 'success' ? 'success' : 'error';
      this.mensaje.colorBtn = type === 'success' ? 'green darken-1' : 'red darken-1';
      this.mensaje.snackbar = true;
    }
  }
};
</script>
